import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Compass, Loader2, ShieldCheck, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { useUser } from "@/lib/user";

const MESSAGES = {
  aucun: "Aucune inscription au parcours du Wyrd n'est associée à ce courriel.",
  echec_paiement: "Votre abonnement au Wyrd est suspendu suite à un échec de paiement — régularisez la mensualité pour retrouver l'accès.",
  resilie: "Votre abonnement au Wyrd a été résilié.",
  paiement_en_attente: "Votre inscription au Wyrd est en attente de paiement — finalisez-la pour accéder aux séances.",
  cycle_termine: "Votre cycle du Wyrd est terminé — rejoignez le prochain cycle pour continuer.",
};

const inputCls = "w-full bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-terra";

export const WyrdGate = ({ onVerified, benefit = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const { user } = useUser();
  const check = async (mail) => {
    setLoading(true);
    try {
      const r = await api.wyrdVerifier(mail);
      setResult(r);
      if (r.actif) onVerified(mail, r);
    } catch {
      setResult({ actif: false, statut: "erreur" });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { if (user?.email) { setEmail(user.email); check(user.email); } }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  const verifier = (e) => { e.preventDefault(); check(email); };
  return (
    <div className="rounded-xl border border-terra/40 bg-terra/5 p-5 space-y-4" data-testid="wyrd-gate">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-terra flex items-center gap-2" data-testid="wyrd-gate-title"><Compass className="w-3.5 h-3.5" /> {benefit ? "Avantage membres Wyrd" : "Réservé aux membres du Wyrd avec abonnement actif"}</p>
      <p className="text-sm text-bark leading-relaxed" data-testid="wyrd-gate-description">{benefit ? "Les membres actifs bénéficient des cercles offerts et de 10 % sur la boutique et les services. " : "Cette séance fait partie du programme Le Wyrd. "}{user ? "Vérification avec le courriel de votre compte…" : "Indiquez le courriel utilisé lors de votre inscription au parcours pour confirmer votre avantage."}</p>
      {!user && <p className="text-xs text-fumee"><Link to="/compte" className="link-line text-terra" data-testid="wyrd-gate-compte">Connectez-vous à votre espace</Link> pour vous inscrire en un clic aux prochaines séances.</p>}
      <form onSubmit={verifier} className="flex flex-col sm:flex-row gap-2">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Courriel de votre inscription au Wyrd" className={inputCls} data-testid="wyrd-gate-email" />
        <button type="submit" disabled={loading} data-testid="wyrd-gate-verifier" className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-earth text-sand text-sm hover:bg-terra hover:text-earth transition-colors duration-300 disabled:opacity-60">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Vérifier
        </button>
      </form>
      {result && !result.actif && (
        <div className="space-y-3" data-testid="wyrd-gate-refus">
          <p className="text-sm text-destructive">{MESSAGES[result.statut] || "Vérification impossible pour le moment — réessayez dans un instant."}</p>
          <Link to="/le-wyrd#inscription" data-testid="wyrd-gate-cta" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-terra text-earth text-sm hover:bg-earth hover:text-sand transition-colors duration-300">
            {result.statut === "aucun" || result.statut === "cycle_termine" ? "Rejoindre Le Wyrd" : "Voir mon inscription au Wyrd"} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      )}
    </div>
  );
};
